import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

export function EnviromentalFactors({ humidity, seasonalWeather, uvExposure }) {

  const humidityIcons = Math.round(humidity / 25)
  const uvExposureIcons = Math.floor(uvExposure / 2)
  humidity = Math.round(humidity)
  uvExposure = Math.round(uvExposure)
  const renderHumidityIcons = () => {
    const icons = [];
    for (let i = 0; i < humidityIcons; i++) {
      icons.push(
        <Ionicons name="water" size={20} color="#3B1C15" style={styles.icon} />
      );
    }
    for (let i = humidityIcons; i < 4; i++) {
      icons.push(
        <Ionicons name="water-outline" size={20} color="#3B1C15" style={styles.icon} />
      );
    }
    return icons;
  };

  const renderUvIcons = () => {
    const icons = [];
    for (let i = 0; i < uvExposureIcons; i++) {
      icons.push(
        <Ionicons name="sunny" size={20} color="#3B1C15" style={styles.icon} />
      );
    }
    for (let i = uvExposureIcons; i < 4; i++) {
      icons.push(
        <Ionicons name="sunny-outline" size={20} color="#3B1C15" style={styles.icon} />
      );
    }
    return icons;
  };

  const renderEnviromentalIcons = () => {
    if (seasonalWeather == '') {
      return []
    }
    else {
      const icons = []
      const wordsArray = seasonalWeather.split(',');
      for (let i = 0; i < wordsArray.length; i++) {
        const seasonalWord = wordsArray[i].trim();
        switch (seasonalWord) {
          case 'rain':
            icons.push(
              <Ionicons name={"rainy"} size={20} color="#3B1C15" style={styles.icon} />
            );
            break;
          case 'snow':
            icons.push(
              <Ionicons name={"snow"} size={20} color="#3B1C15" style={styles.icon} />
            );
            break;
          case 'cloud':
            icons.push(
              <Ionicons name={"cloud"} size={20} color="#3B1C15" style={styles.icon} />
            );
            break;
          case 'sun':
            icons.push(
              <Ionicons name={"partly-sunny"} size={20} color="#3B1C15" style={styles.icon} />
            );
            break;
          default:
            break;
        }
      }
      return icons
    }
  }

  // const renderAirQuality = () => {
  //   const icons = [];
  //   for (let i = 0; i < uvExposure; i++) {
  //     icons.push(
  //       <MaterialCommunityIcons name={"face-mask"} size={20} color={"#3B1C15"} style={styles.icon} />
  //     );
  //   }
  //   for (let i = uvExposure; i < 4; i++) {
  //     icons.push(
  //       <MaterialCommunityIcons name={"face-mask-outline"} size={20} color={"#3B1C15"} style={styles.icon} />
  //     );
  //   }
  //   return icons;
  // };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Environmental Factors</Text>
      <View>
        <View style={styles.factorsContainer}>
          <View style={styles.labelsContainer}>
            <View style={styles.factor}>
              <Text style={styles.factorLabel}>Humidity: {humidity}</Text>
            </View>
            <View style={styles.factor}>
              <Text style={styles.factorLabel}>UV Exposure: {uvExposure}</Text>
            </View>
            {seasonalWeather !== '' && (
              <>
                <View style={styles.factor}>
                  <Text style={styles.factorLabel}>Seasonal Weather</Text>
                </View>
              </>
            )}
          </View>

          <View style={styles.iconsContainer}>
            <View style={styles.factor}>
              {renderHumidityIcons()}
            </View>
            <View style={styles.factor}>
              {renderUvIcons()}
            </View>
            {seasonalWeather !== '' && (
              <>
                <View style={styles.factor}>
                  {renderEnviromentalIcons()}
                </View>
              </>)}
            {/* <View style={styles.factor}>
              {renderAirQuality()}
            </View> */}
          </View>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#EFE5DA',
    justifyContent: 'center',
    alignItems: 'center',

  },
  title: {
    fontFamily: 'DM Serif Display',
    fontSize: 30,
    fontWeight: 'bold',
    color: '#3B1C15',
    marginTop: 10,
    marginBottom: 10,
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  factorsContainer: {
    width: '80%',
    borderRadius: 20,
    paddingVertical: 20,
    paddingHorizontal: 30,
    flexDirection: 'row',
    //justifyContent: 'space-between',
    //alignItems: 'center',
  },
  labelsContainer: {
    flexDirection: 'column',
    justifyContent: 'space-between',
    //marginRight: 20,
  },
  iconsContainer: {
    flexDirection: 'column',
    justifyContent: 'space-between',
    //marginLeft: 20,
  },
  factor: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
  },
  factorLabel: {
    fontSize: 17,
    fontWeight: 'bold',
    textAlign: 'left',
    marginRight: 10,
  },
  icon: {
    marginRight: 5,
  },
});
